// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2RB9G","consentsList":"PatientConsents_consentsList__Vp4B6","consentsListEmpty":"PatientConsents_consentsListEmpty__1rgVI"};